import { render, staticRenderFns } from "./napkins-item.vue?vue&type=template&id=1df4608d"
import script from "./napkins-item.vue?vue&type=script&lang=js"
export * from "./napkins-item.vue?vue&type=script&lang=js"
import style0 from "./napkins-item.vue?vue&type=style&index=0&id=1df4608d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports